import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { PassphraseLoginComponent } from '@common-standalone/2fa/passphrase-login/passphrase-login.component';
import { SearchComponent } from '@common-standalone/advanced-search/search/search.component';
import { CreateOptionsComponent } from '@common-standalone/file-operations/create-options/create-options.component';
import { NewCreateBtnComponent } from '@common-standalone/file-operations/new-create-btn/new-create-btn.component';
import { OtpVerificationComponent } from '@common-standalone/logins/otp-verification/otp-verification.component';
import { BytesConversionPipe } from '@common-standalone/pipes/bytes-conversion.pipe';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { TEAM_FOLDER_ROUTES } from '@commoncore/enums/ROUTES';
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { UserLoginImplementation } from '@commoncore/implementation/UserLoginImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { ActiveRepo } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { AllFilesController } from '@mainrepo/app/core/controller/AllFilesController';
import { IndexedDBModule } from '@mainrepo/app/core/database/IndexedDBManager';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';
import { TwoFaModule } from '@modules/helper-modules/two-fa.module';
import { GuidedTour, GuidedTourService, Orientation } from 'ngx-guided-tour';
import { CloudPcMenuComponent } from '../cloud-pc-menu/cloud-pc-menu.component';

@Component({
  selector: 'common-new-left-menu',
  standalone: true,
  imports: [DependenciesModule,PassphraseLoginComponent,TwoFaModule,SearchComponent,CreateOptionsComponent,BytesConversionPipe,CloudPcMenuComponent,NewCreateBtnComponent,OtpVerificationComponent],
  templateUrl: './new-left-menu.component.html',
  styleUrl: './new-left-menu.component.scss'
})

export class NewLeftMenuComponent {

  menuItems: any = [];
  secondryMenuItems: any = [];
  moreMenuItems: any = [];
  trashItem: any;
  goToAdminConsoleItem:any;
  storage:any;
  footerLinks: any = [];
  storagePercentage: number = 0; // New variable to store percentage

  public openSideNavigation:boolean = false;
  public redirectionUrl:string="";
  public userDetails:any = {};
  public controller: any;
  public implRef: any;
  public universalService: any;
  public folderService:any;
  public leftMenu :any;
  public userData:any ={};
  searchForm: FormGroup;
  router: Router;
  listService:any;
  shareAccessService:any;
  localStorageService:any;
  cleverTapEventsService: any;
  sessionStorageService:any;
  userLoginController: UserloginController ;
  loginImplRef:UserLoginImplementation;
  searchService:any;
  http:any;
  localStorageSvc: LocalStorageSvc;
  userTotalStorage: number;
  userTotalUsedStorage: number;
  leftMenuOptionData : any;
  db: IndexedDBModule;
  dbTutorialRes: any = [];
  entTourMainRepoSeen: boolean = false;
  entTourMainRepoNoadminSeen: boolean = false;
  currentView:any = ""
  isContactSearch:boolean=false
  hideContactSearchBox:boolean=true;
  errorMsg:any='';
  selectedMenuItem: any = null;
  
  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if ( this.universalService.currentTab=='Contact' && this.universalService.isMobileDevice && event.key === "Enter") {
       this.getSearchContacts();
    } 
  }
  @ViewChild('searchvalue') searchvalue:ElementRef;

  constructor(public globalService:GlobalService,
    private cdRef :ChangeDetectorRef,private guidedTourService: GuidedTourService) { 
    this.setEnvObjects();
    this.registeringevents();
  }

  async ngOnInit(): Promise<void> { 
    var self = this;
    self.errorMsg=''
    self.userDetails = self.localStorageSvc.getUserData(true);
    self.leftMenu = self.universalService.leftMenu;
    self.loadSidebarData();
    

    self.userLoginController=UserloginController.getInstance(self.globalService)
    self.loginImplRef = self.userLoginController.userLoginImplementation;
    
    if(self.universalService.activeRepo == 'main'){
      self.controller = AllFilesController.getInstance(this.globalService);
      self.implRef = this.controller.allFilesImplementation;
    }

    if(self.localStorageService.getUserData(true)){ // this condition is added to populate the left menu data as soon as the menu loads,as the left menu component not being loaded immediatly on app load, instead it is conditionally loaded so the subscriptions are not done by the time observers are emitted.
      self.userTotalStorage = (self.userDetails.quota) ? self.userDetails.quota.totalAllocatedQuota : self.userDetails.totalAllocatedQuota;
      self.userTotalUsedStorage = (self.userDetails.quota) ? self.userDetails.quota.totalUsedQuota : self.userDetails.totalUsedQuota;
      self.universalService.firstName = self.userDetails.firstName;
      self.universalService.lastName = self.userDetails.lastName;
      self.universalService.emailId = self.userDetails.emailId;
      self.universalService.setUpdateProfileIconPath();
    }
    self.universalService.setUpdateProfileIconPath();
    AppEvents.globalObservable.subscribe(async response=>{
      if(response["leftMenuContents"] == true){ 
        self.leftMenu = self.universalService.leftMenu;
        self.updatedLeftMenuOptions();
        // self.applyMenuVisibilityConditions();
        // this.showHidePrivateFolderOption(); // Manage private folder show/hide
        self.leftMenuOptionData = self.leftMenu['leftMenuOptions'];
        self.userData = self.localStorageService.getUserData(true);
        self.userTotalStorage = self.userData?.quota?.totalAllocatedQuota;
        self.userTotalUsedStorage = self.userData?.quota?.totalUsedQuota;
        self.universalService.showLoader = false;
        self.setEnterpriseOptions();
        self.universalService.setWidthforLogin();
        self.universalService.setUpdateProfileIconPath();
      }
    })

    setTimeout(()=>{
      self.subscribeToUpdateStoarge();
    },1000)
    
  }
  ngAfterViewInit(){
    this.initaitEntTutorials();
    this.expandMoreMenuAndHighlight();
  }
  redirectFooterLinks(item){
    let url;
    if(item.title === 'Go to Admin Console'){
      this.switchAdminConsoleView();
    }else if(item.title === "Download App" || item === "Download App"){
      url = '/downloadApp';
      window.open(url, "_blank", "noopener, noreferrer");
    }else if(item.title === "Terms & Conditions"){
      url = 'https://static.jiocloud.com/tos.html';
      window.open(url, "_blank", "noopener, noreferrer");
    }
  }
  showDefaultIcon(defaultIconEl){
    defaultIconEl.style.display = 'block';
  }
  showContactSearch(action){
    this.errorMsg=''
    this.universalService.contactSearchValue =''
    this.hideContactSearchBox=action;
    if(action && this.isContactSearch){
      this.universalService.contactSearchValue = ''
      AppEvents.emit(EventsList.CONTACT_SEARCH_CLICKED)
    }
    this.isContactSearch = false;

  }
 
  setEnterpriseOptions(){ 
    let userData = this.localStorageSvc.getUserData(true) 
    if(userData && userData["jcEntInfo"]){
      if(localStorage.jio && userData){
        if(userData.jcEntInfo){
          this.universalService.showFeaturesForEntUsers = true;
          userData.jcEntInfo.isAllowPublicShare == "Y"? this.universalService.isAllowPublicShare = true : this.universalService.isAllowPublicShare = false;
          if(userData.jcEntInfo.isAllowExtPrivateShare == "Y"){
            this.universalService.isAllowExtPrivateShare = true;
            this.universalService.isAllowEnternalPrivateShare = false;
          }else if(userData.jcEntInfo.isAllowExtPrivateShare == "N"){
            this.universalService.isAllowEnternalPrivateShare = true;
            this.universalService.isAllowExtPrivateShare = false;
          }
        }else{
          this.universalService.showFeaturesForEntUsers = false;
          this.universalService.isAllowPublicShare = true;
          this.universalService.isAllowEnternalPrivateShare = false;
          this.universalService.isAllowExtPrivateShare = false;
        }
      } 
    }else{
      this.universalService.showFeaturesForEntUsers = false;
      this.universalService.isAllowPublicShare = true;
      this.universalService.isAllowEnternalPrivateShare = false;
      this.universalService.isAllowExtPrivateShare = false;
      Array.from(document.querySelectorAll('.hideOption')).forEach(function(el) { 
        el?.classList.remove('hideOption');
      });
    }
  }

  openSearchPage(){
    this.searchService.lastSearchQuery = null;
    this.searchService.openAutoSearch.next(true);
  }
  getSearchContacts(){
    if(this.searchvalue.nativeElement.value.length>1){
      this.errorMsg=''
      this.isContactSearch = true
      this.universalService.contactSearchValue = this.searchvalue.nativeElement.value
      AppEvents.emit(EventsList.CONTACT_SEARCH_CLICKED)
    }else{
       this.universalService.showToast(this.universalService.contactSearchValidationMessage,'contactsearcherror')
      
      //this.errorMsg='Please enter atleast 2 characters to search contact'
    }
  }
  getContactSorting(){
    AppEvents.emit(EventsList.CONTACT_SORTING)
  }
  initaitEntTutorials(){
    if(this.universalService.activeRepo == ActiveRepo.SHARE){
      return
    }

    this.userData = this.localStorageService.getUserData(true);
    if(!this.universalService.isMobileDevice && this.router.url.includes('/home') && this.userData['isNewUserNotify'] == 'Y'){
      setTimeout(async ()=>{
        if(this.userData && this.userData['jcEntInfo'] && this.userData['jcEntInfo']['entUserRole'] == 'A' ){
          this.universalService.showTourForAllJioCloudUsr = false;
          let tourStatus = localStorage.getItem('entTourMainRepoSeen')
          if(tourStatus != 'true'){
            this.universalService.isTourON = true;
            setTimeout(()=>{
              this.startTour();
          },500)
          }else{
            AppEvents.emit(EventsList.STOP_ENT_TOUR_lEFT_MENU);
            this.universalService.isTourON = false;
          }
        }else{
          this.universalService.isTourON = false;
          let tourStatus = localStorage.getItem('entTourMainRepoNoadminSeen')
          if(tourStatus != 'true'){
            this.universalService.showTourForAllJioCloudUsr = true;
            setTimeout(()=>{
              this.startTour();
          },500)
          }else{
            this.universalService.userHasCompletedOnBoardingFlow = true;
            AppEvents.emit(EventsList.STOP_ENT_TOUR_lEFT_MENU);
          }
        }
      },250)
    }else{
      this.universalService.userHasCompletedOnBoardingFlow = true;
    }
  }
  setEnvObjects(){
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.universalService = this.globalService.getUniversalServiceRef();
    this.folderService = this.globalService.getFolderServiceRef();
    this.router = this.globalService.getRouterRef();
    this.listService = this.globalService.getListServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.sessionStorageService = this.globalService.getSessionStorageSvcRef();
    this.searchService = this.globalService.getSearchServiceRef();
    this.http = this.globalService.getHttpClientRef();
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
  }
  loadSidebarData(): void {
    let self= this;
    setTimeout(async ()=>{
      if(self.universalService.userLoggedIn){
        if(self.universalService.leftMenu.loginOptions && self.universalService.activeRepo == ActiveRepo.SHARE){
          self.universalService.leftMenu = ''
          await self.universalService.fetchJSONContent();
        }
      }
      self.leftMenu = self.universalService.leftMenu;
      self.menuItems = self.leftMenu.menuItems;
      self.secondryMenuItems = self.leftMenu.secondryMenuItems;
      self.moreMenuItems = self.leftMenu.MoreLeftMenu
      self.trashItem = self.leftMenu.trash;
      self.goToAdminConsoleItem = self.leftMenu.goToAdminConsole;
      self.storage = self.leftMenu.storage;
      self.footerLinks = self.leftMenu.footerLinks;
      self.applyMenuVisibilityConditions();
    },300)
  }

  checkIfLeftMenuIsUpdatedOrNot(obj1,obj2){
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }

  updatedLeftMenuOptions(){
    this.applyMenuVisibilityConditions();
    // const isSecondryMenuUpdated = this.checkIfLeftMenuIsUpdatedOrNot(this.secondryMenuItems, this.leftMenu.secondryMenuItems);
    // if(!isSecondryMenuUpdated){
    //   this.secondryMenuItems = this.leftMenu.secondryMenuItems;
    // }
    // if(this.moreMenuItems[0] && this.moreMenuItems[0].moremenu){
    //   const isMoreMenuUpdated = this.checkIfLeftMenuIsUpdatedOrNot(this.moreMenuItems[0].moremenu, this.leftMenu.MoreLeftMenu[0].moremenu);
    //   if(!isMoreMenuUpdated){
    //     this.moreMenuItems[0].moremenu = this.leftMenu.MoreLeftMenu[0].moremenu; 
    //   }
    // }
    this.goToAdminConsoleItem = this.leftMenu.goToAdminConsole;
  }


  subscribeToUpdateStoarge(){
    AppEvents.updateLeftMenuStorage.subscribe(suc => {
      if(suc["updateLeftMenuStorage"] == true){
        this.userData = this.localStorageService.getUserData(true);
        AppEvents.updateAuthData.next({updateAuthData:true,userData:this.userData});
        this.userDetails =  this.userData
        this.userTotalStorage = this.userData.quota.totalAllocatedQuota;
        this.userTotalUsedStorage = this.userData.quota.totalUsedQuota;
        this.universalService.firstName = this.userDetails.firstName;
        this.universalService.lastName = this.userDetails.lastName;
        this.universalService.emailId = this.userDetails.emailId;
        this.universalService.setUpdateProfileIconPath();
      }
    })
   }
  setCurrentTab(){
    if (this.router.url.includes('/people') || this.router.url.includes('/people/face')){
      this.cleverTapEventsService.experienceNowModalLocation = 'Web';
    }
   }
   closeSideNav(){
     this.universalService.sideNavVisible= false; 
     this.setCurrentTab();
   }
  toggleDropdown(item) {
    let el = document.getElementById('left-more-menu')
    if(el){
      if(item.expanded != undefined && item.expanded == true){
        item.expanded  = false
        el.classList.remove('expanded')
        
      }else if(item.expanded != undefined && item.expanded == false){
        item.expanded = true
        el.classList.add('expanded')
      }else{
        this.moreMenuItems[0].expanded = false
        el.classList.remove('expanded')
      }
    }
  }
  getBackgroundImageUrl() {
    return 'url('+USER_DETAILS["USER_DETAILS"]["profilePhotoPath"]+')';
  }

  logCleverTapForViewStorage() {
   this.cleverTapEventsService.onUserStorageClicked();
  }
  async redirectToRespsectiveRoute(item) {
    let route = item.id;
    let link = item.link;
    
    if(item.id != 'Favorites' && item.id != 'Contacts' && item.id != 'cloudBridge' && item.id != 'PrivateFolder'){
      // this.isMenuItemSelected(item)
      this.toggleDropdown(item);
    }
  
    this.universalService.targetUrl = link
    if(route != "Login" && route != "Download" && this.universalService.activeRepo == "share"){
      this.shareAccessService.showUnivShareLinkFiles = false;
      this.universalService.isUnivSharelink = false; 
    }
    this.currentView = this.universalService.selectedTab;
    if(this.currentView  == "My Files")
      this.currentView = "MyFiles";
    const privateFolderKey = this.localStorageSvc.getPrivateFolderKey();
    if(this.router.url.includes('recent') || (!this.router.url.includes(USER_DETAILS["USER_DETAILS"]["rootFolderKey"]) && this.universalService.openFolderContent) || this.router.url == "/favorites/myalbums"  || this.router.url == '/shared/sharedwithme' || this.router.url == '/shared/sharedlinkbyme' || (privateFolderKey && !this.router.url.includes(privateFolderKey) && this.universalService.openFolderContent))  {
      this.currentView = "";
    }
    
    if(route != this.currentView && route != 'PrivateFolder'){
      this.resetDataWhileSwitchingMenu(route);
      this.resetFolderDataOnClickingFromLeftMenu();
    }

     this.exitAddMemberFamilyShareScreen();
     if(this.router.url.includes('/addmember')){
      this.universalService.showCreateFolderAndUploadButtons = false;
       await this.sleep(500);
      if($('.inviteDiscardModal').length == 0){
        return
      }
    }
    var url = ""
    if(this.universalService.activeRepo == 'share' && route != 'Login' && route != 'Download' ){
      url = url + link;
      var ele = document.getElementById(route);
      if(ele){
        ele.setAttribute('class', "menu-item")
      }
      window.location.href = url;
    }
    if (route == 'Login') {
        this.universalService.sideNavVisible = false;
        this.router.navigate(["/signin"],{queryParamsHandling:'preserve'});
        this.cleverTapEventsService.screenViewedLogin();
      return;
    } else {
      if (route == 'Download') {
        url = '/downloadApp';
        window.open(url, "_blank", "noopener, noreferrer");
        this.universalService.sideNavVisible = false;
        return;
      } else if(route == 'Home'){
        if(this.universalService.currentTab!=route){
          this.universalService.showCreateFolderAndUploadButtons = true;
          this.universalService.objectsPreviewArray = [];
          this.universalService.mobileSelectedObj = [];
          this.universalService.currentTab ='Home';
          this.universalService.selectedTab = "Home"
          this.universalService.stopAndCloseAudioPlayer();
          this.router.navigate(['home']);
          return;
        }
      }else if(route == 'Favorites'){

        if(this.universalService.currentTab!=route){
          this.universalService.objectsPreviewArray = [];
          this.universalService.mobileSelectedObj = [];
          this.universalService.currentTab ='Favorites'
          this.universalService.selectedTab = "Favorites"
          this.universalService.stopAndCloseAudioPlayer();
          this.router.navigate(['favorites','myfiles']);
          return;
        }
      } else if(route == 'Trash'){
        if(this.universalService.currentTab!=route){
          this.universalService.objectsPreviewArray = [];
          this.universalService.mobileSelectedObj = [];
          this.universalService.currentTab ='Trash';
          this.universalService.selectedTab = "Trash"
          this.universalService.stopAndCloseAudioPlayer();
          this.cleverTapEventsService.screenViewedMyFileTrash();
          this.router.navigate(['trash']);
          return;
        }
      }else if (route == "Recent Files"){
        if(!(this.universalService.currentTab=='allfiles' && this.universalService.fetchAllRecentFiles)){
          this.universalService.objectsPreviewArray = [];
          this.universalService.mobileSelectedObj = [];
          this.universalService.currentTab = 'allfiles';
          this.universalService.selectedTab = "My Files"
          this.universalService.stopAndCloseAudioPlayer();
          this.resetFolderDataOnClickingFromLeftMenu();
          this.router.navigate(['filter','recents']);
          
          return;
        }
      }else if (route == 'MyFiles' || route == 'MyFilesImg') {
        if(!(this.universalService.currentTab=='allfiles' && !this.universalService.fetchAllRecentFiles)){
          if(this.router.url.includes('/allfiles/')){
            AppEvents.emit(EventsList.MYFILES_TABBED_VIEW);
          }
          this.universalService.objectsPreviewArray = [];
          this.universalService.mobileSelectedObj = [];
          this.universalService.currentTab ='allfiles'
          this.universalService.selectedTab = "My Files"
          this.universalService.showJustifiedLayout = false;
          if(this.router.url.includes('/allfiles') && !this.router.url.includes('/album')){
            this.universalService.currentTab ='allfiles';
          }
          if(!this.universalService.openFolderContent && this.universalService.foldersArray.length == 0){
            this.universalService.emptyTab = true;
          }
          this.cleverTapEventsService.screenViewedAllFiles();
          this.resetFolderDataOnClickingFromLeftMenu()
          this.router.navigate(['allfiles',USER_DETAILS["USER_DETAILS"]["rootFolderKey"]])
          return;
        }
      }else if(route == 'Albums'){
        this.cleverTapEventsService.myAlbumsScreenViewed()
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "Albums";
        this.universalService.currentTab = "My Albums";
        this.universalService.showCreateFolderAndUploadButtons = this.universalService.isMobileDevice ? true : false;
        this.router.navigate(['/albums']);
      }else if(route == 'People'){
        this.universalService.currentTab = "People";
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "People";
        this.cleverTapEventsService.userPeopleClicked();
        AppEvents.emit(EventsList.CLEAR_PEOPLE_DATA_IN_MEMORY);
        this.router.navigate(['people'])
      }else if(route == 'Places'){
        this.localStorageService.removeItem(LocalStorageProps.PLACE_TAB_SORT_TYPE)
        this.universalService.currentTab = "Places";
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "Places";
        AppEvents.emit(EventsList.CLEAR_PEOPLE_DATA_IN_MEMORY);
        this.router.navigate(['places'])
      }else if(route == 'Contacts'){
        this.universalService.selectedTab = "Contacts"
        this.cleverTapEventsService.screenViewedContacts();
        this.universalService.stopAndCloseAudioPlayer();
        this.router.navigate(['contacts']);

      }else if(route == 'userprofile' || route == 'userprofilelist' || route == 'Refer' || route == 'Logout' || route == 'Profile'){
        this.universalService.selectedTab = "Profile"
        this.universalService.currentTab = "Profile";
        this.cleverTapEventsService.screenViewedProfile();
        var userData = this.localStorageService.getUserData(true);
        this.universalService.stopAndCloseAudioPlayer();
        if(userData != '' && userData != undefined){
          this.universalService.showSortButtons=false
          AppEvents.updateAuthData.next({updateAuthData:true,userData:userData});
          this.router.navigate(['userprofile']);
        }
        return
      }else if (route == 'Shared'){ 
        this.universalService.selectedTab = "Shared Files"
        this.universalService.objectsPreviewArray = [];
        this.universalService.mobileSelectedObj = [];
        this.resetFolderDataOnClickingFromLeftMenu();
        this.cleverTapEventsService.onSharingOptionClick();
        this.universalService.stopAndCloseAudioPlayer();
        this.router.navigate(['shared/sharedbyme']);
        return;
      } else if(route == 'dashboard'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "dashboard"
        this.router.navigate([link])
      } else if(route == 'manageusers'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "manageusers"
        this.universalService.showLoader = true;
        this.router.navigate([link])
      } else if(route == 'reports'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "reports"
        this.universalService.showLoader = true;
        this.router.navigate([link])
      } else if(route == 'settings'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.selectedTab = "settings"
        this.universalService.showLoader = true;
        this.router.navigate([link])
      } else if(route == 'teamfolders'){
        this.cleverTapEventsService.teamFolderScreeViewed('teamFolderList');
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.currentTab = 'teamfolders';
        this.universalService.selectedTab = "teamfolders"
        this.universalService.headingTitle.set("Team Folders");
        // this.universalService.showLoader = true;
        this.resetFolderDataOnClickingFromLeftMenu();
        this.router.navigate([link])
      } else if(route == 'PrivateFolder'){
        AppEvents.globalObservable.next({"checkIfPrivateFolderShouldActivate":true});
      }  else if(route == 'cloudBridge'){
        this.universalService.showCreateFolderAndUploadButtons = false;
        this.universalService.objectsPreviewArray = [];
        this.universalService.mobileSelectedObj = [];
        this.universalService.selectedNodes = [];
        this.universalService.currentSelectedDevice= [];
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.currentTab = 'CloudBridge';
        this.universalService.selectedTab = "CloudBridge"
        this.universalService.headingTitle.set("CloudBridge");
        this.router.navigate(['cloudbridge']);
      } else if(route == 'DigiLocker'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.currentTab = 'DigiLocker';
        this.universalService.selectedTab = "DigiLocker"
        this.universalService.headingTitle.set("DigiLocker");
        this.router.navigate(['digilocker']);
      } else if(route == 'JioPhoneCallAI'){
        this.universalService.stopAndCloseAudioPlayer();
        this.universalService.currentTab = 'JioPhoneCallAI';
        this.universalService.selectedTab = "JioPhoneCallAI"
        this.universalService.headingTitle.set("JioPhoneCallAI");
        this.router.navigate(['jpai']);
      }else if(route == 'Events'){
        let nsmurl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]
        let dcCode = "jaws"
        if(nsmurl.toLowerCase().includes("jmng2")){
          dcCode = "jmng2"
        }else if(nsmurl.toLowerCase().includes("jmng")){
          dcCode = "jmng"
        }
        this.universalService.stopAndCloseAudioPlayer();
        this.cleverTapEventsService.eventsTapped();
        let jcJWT = this.localStorageService.getLocalProperty(LocalStorageProps.JC_JWT,false);
        url = ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME]["eventLoginUrl"]+jcJWT+"&dcCode="+dcCode
        window.open(url, "_self","noopener, noreferrer");
        return;
        // url = '/downloadApp';
        // window.open(url, "_blank", "noopener, noreferrer");
        
      }
 
      else{
        url = url + link;
        var ele = document.getElementById(route);
        ele.setAttribute('class', "menu-item")
        window.location.href = url;
      }    
    }
    this.redirectionUrl = url
  }

  resetDataWhileSwitchingMenu(route){
    AppEvents.albumDetails.observers = [];
    this.listService.resetColumnHeaders();
    //this.listService.listViewSortOrder = "&sort=%2DfileCreatedDate";
    this.listService.listViewSortOrder = (localStorage.listViewSortOrder == null)?"&sort=%2DfileCreatedDate":localStorage.listViewSortOrder;
    this.universalService.sharePublicSortByUploadDate = "";
    localStorage.removeItem("planPurchaseSuccess");
    if(!this.universalService.emptyTab && this.listService){ // to unselect previously selected items
      this.listService.deSelectAll();
    }
    this.hideContactSearchBox = true;
    this.universalService.emptyTab = false;
    this.universalService.showLoader = false;
    if(this.universalService.userLoggedIn) {
      this.universalService.currentTab = "";
    }
    this.universalService.showJustifiedLayout = false;
    this.universalService.deletedFileShare = false;
    this.universalService.uploadButtonClicked = false;
    this.universalService.isMobileShareOptionClicked = false;
    this.universalService.moreOptionsOnMobileClicked = false;
    this.universalService.isUserOnSharedLinkByMe = false;
    
    if(route != "Login"){
      this.shareAccessService.singleObjectShared = "";
      this.sessionStorageService.setSingleSharedObject(this.shareAccessService.singleObjectShared,true)
    }
    this.universalService.selectedTab = "";
    this.universalService.currentAlbum = undefined;
    this.listService.listOptions.rowSelection = 'multiple'
    if(route!="Shared"){
      this.universalService.emptyShared = false;
      this.universalService.showCreateFolderAndUploadButtons = true;
    }
    if(route != "Trash"){
      this.universalService.emptyTrash = false;
    }

    if(route == "People" || route == "teamfolders" || route == "JioPhoneCallAI" ||route == "Places"){
      this.universalService.showCreateFolderAndUploadButtons = false;
    }
    this.shareAccessService.isSharedFilesView = false;
    if(route != "Albums" && route != "Profile" && route != "Contacts" && route != "Refer" && route != 'Logout' && route != 'PrivateFolder'){
      if(route=="Login" && this.universalService.activeRepo != 'share'){
        this.universalService.objectsPreviewArray = [];
      }
      this.universalService.mobileSelectedObj = [];
    }
    this.universalService.isMobileTopMoreOptionMenu = false;
    if(this.universalService.mobileSelectionModeOn){
      this.universalService.switchOffMobileSelectionMode();
    }
    this.universalService.openMoreOptions = false;
  }

  resetFolderDataOnClickingFromLeftMenu(){ // this function is called when clicking on left menu tabs to reset the breadcrumb and folder data
    if(this.folderService.breadCrumbsList[0]){
      this.folderService.openFolderFromBreadCrumb(this.folderService.breadCrumbsList[0].objectKey);
    }
    this.universalService.openFolderContent = false;
    this.universalService.insideFolder = false;
    this.folderService.clickedFolderName = this.folderService.currentFolderName;
    this.sessionStorageService.removeSessionProperty(SessionStorageProps.CURRENT_FOLDER_KEY); 
    this.localStorageService.removeLocalProperty(LocalStorageProps.SHARED_FOLDER);
    this.folderService.manageBreadCrumbs(this.folderService.currentFolderKey, this.folderService.currentFolderName, this.folderService.currentFolder);
  }
  exitCurrentAlbum(){
    this.universalService.exitCurrentAlbum();
  }
  openView(){
    AppEvents.emit(EventsList.CHANGE_VIEW);
  }
  navigateBreadCrumb(folderKey){
    AppEvents.globalObservable.next({"navigate":true,"folderKey":folderKey})
  }
  exitAddMemberFamilyShareScreen(){
    if(this.router.url.includes('/familyshare/addmember')){
      AppEvents.emit(EventsList.CLICKED_BACK_FROM_ADD_MEMBER)
    }else if(this.router.url.includes('/familyshare') || this.router.url.includes('/orderhistory')){
      this.router.navigate(['userprofile']);
    }else if(this.router.url.includes('/people/face')){
      this.cleverTapEventsService.experienceNowModalLocation = 'Web';
      this.router.navigate(['people']);
    }else if(this.router.url.includes(TEAM_FOLDER_ROUTES["TEAM_FOLDER_METADATA"] + "/")){
      this.router.navigate(['teamfolders']);
    }else if(this.router.url.includes('/status') && this.universalService.currentTab == 'CloudBridge'){
      this.router.navigate(['cloudbridge']);
    }
  }
  sleep(milliseconds){
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }
  switchAdminConsoleView(){
    var target = "_blank";
    window.open("/enterprise/dashboard",target, "noopener, noreferrer");
  }

  private registeringevents(){
    AppEvents.on(EventsList.STOP_ENT_TOUR_lEFT_MENU, async ()=> {
      if(this.userData && this.userData['jcEntInfo'] && this.userData['jcEntInfo']['entUserRole'] == 'A'){
        localStorage.setItem("entTourMainRepoSeen",'true')
        this.universalService.isTourON = false;
      }else{
        localStorage.setItem("entTourMainRepoNoadminSeen",'true')
        this.universalService.showTourForAllJioCloudUsr = false;
      }
    })
    AppEvents.on(EventsList.SHOW_EMAIL_VERIFICATION_MODAL_POST_ONBOARDING, async ()=> {
      this.universalService.userHasCompletedOnBoardingFlow = true;
    })
  }

  public readonly IFOTOUR: GuidedTour = {
    tourId: "Infotour",
    useOrb: false,
    completeCallback() {
      AppEvents.emit(EventsList.STOP_ENT_TOUR_lEFT_MENU);
      AppEvents.emit(EventsList.SHOW_EMAIL_VERIFICATION_MODAL_POST_ONBOARDING);
    },
    steps: [
      {
        selector: ".usr-help-access-btn",
        content: "<div class='info-modal-wrap'><img src='../assets/images/info-arrow-top.svg' class='info-arrow-top' /><div class='graphic-holder mb-3'><img src='../assets/images/Thinking-face-amico.svg' alt='' class=''></div><div class='description text-left mb-3'><h1>Hey <span class='userFirstName'></span>,</h1><h3>Welcome to the Help Section!</h3><p>We're here to help, whether you're new or need assistance. Check our FAQs for guidance. If you can't find what you're looking for, contact our support team for assistance.</p></div></div>",
        orientation: Orientation.BottomRight
      }
    ],
    preventBackdropFromAdvancing:true
  };
  
  public readonly TOUR: GuidedTour = {
    tourId: "tour",
    useOrb: false,
    completeCallback() {
      AppEvents.emit(EventsList.STOP_ENT_TOUR_lEFT_MENU);
    },
    steps: [
      {
        selector: "div.switch-admin",
        content: '<div class="admin-console-modal-wrap"><img src="../assets/images/arrow-console.svg" class="arrow-console" /><div class="graphic-holder mb-3"><img src="../assets/images/admin-console.svg" alt="" class=""></div><div class="description text-left mb-3"><h1>Hey <span class="userFirstName"></span>,</h1><h3>Welcome to JioAICloud Enterprise!</h3><p>To access the Admin console, simply hover over the left-hand menu and click on the option "Go to Admin Console".</p></div></div>',
        orientation: Orientation.Right,
        closeAction: this.firstTourClose
      },
      {
        selector: ".usr-help-access-btn",
        content: "<div class='info-modal-wrap'><img src='../assets/images/info-arrow-top.svg' class='info-arrow-top' /><div class='graphic-holder mb-3'><img src='../assets/images/Thinking-face-amico.svg' alt='' class=''></div><div class='description text-left mb-3'><h1>Hey <span class='userFirstName'></span>,</h1><h3>Welcome to the Help Section!</h3><p>We're here to help, whether you're new or need assistance. Check our FAQs for guidance. If you can't find what you're looking for, contact our support team for assistance.</p></div></div>",
        orientation: Orientation.BottomRight
      }
    ],
    preventBackdropFromAdvancing:true
  };

  startTour() {
    if(this.universalService.showTourForAllJioCloudUsr){
      this.guidedTourService.startTour(this.IFOTOUR);
    }else{
      this.guidedTourService.startTour(this.TOUR);
    }
    setTimeout(()=>{
      this.updateTourcontent();
    })
  }
  updateTourcontent(){
    let tourEl = document.querySelector(".tour-content")as any;
    tourEl.classList.add('onboarding-modal-main');
    let tourHighlight = document.querySelector(".guided-tour-memory-overlay")as any;
    let userNameEl = document.querySelector(".userFirstName")as any;
    userNameEl.innerHTML = this.universalService.firstName;
    if(!this.universalService.showTourForAllJioCloudUsr){
      tourHighlight.classList.add('custometTourHighlightRepo')
    }else{
      this.firstTourClose();
    }
  }
  firstTourClose(){
    setTimeout(()=>{
      // postLoginDesktopLeftMenu ****tourLeftMenu
      let userNameEl = document.querySelector(".userFirstName")as any;
      userNameEl.innerHTML = (document.querySelectorAll('.u-name')[0].innerHTML).split(' ')[0]
      let tourHighlight = document.querySelector(".guided-tour-memory-overlay")as any;
      if(tourHighlight){
        tourHighlight.classList.remove('custometTourHighlightRepo');
      }
      let tourStep = document.querySelector('.tour-step')as any;
      let newLeft  = parseInt((tourStep.style.left).split('px')[0]) - 90
      tourStep.style.left = newLeft + 'px';
      let tourEl = document.querySelector(".tour-content")as any;
      tourEl.classList.add('onboarding-modal-main');
      let tourButtons =document.querySelector(".tour-buttons")as any;
      tourButtons.style.left = '0';
      if(tourHighlight){
        tourHighlight.classList.add('custometTourHighlightRepo2')
      }
    },90)
  }

  viewPlanDetails(e){
    e.stopPropagation();
    this.sessionStorageService.setBuyStorageAlreadyInitiated(true);
    this.universalService.activeRepo == 'share' ? window.open(("/buystorage"),"_self", "noopener, noreferrer") : this.router.navigate(['/buystorage']);
  }
  openProfileView(){
    if(this.universalService.activeRepo == ActiveRepo.MAIN){
      this.router.navigate(['userprofile']);
    }else{
      window.location.href = "/userprofile";
    }
  }
 
  isMenuItemSelected(id) {
    if(id == 'userprofile' || (id == 'PrivateFolder' && !this.router.url.includes('privatefolder'))){
      return
    }
    let elArray = document.querySelectorAll('.left-menu-selected-item')
    elArray.forEach(e =>{
      if(e){
        e.classList.remove('left-menu-selected-item')
      }
    });
    let elId = id
    let el = document.getElementById(elId);
    if(el){
      el.classList.add('left-menu-selected-item')
  }
  }
  setMenuItemVisibility(item) {
    let env = ENV_CONSTANTS["constants"];
    this.userDetails = this.localStorageSvc.getUserData(true);
    if ((this.userDetails && this.universalService.iframeLogin && item.title === 'CloudBridge') || (this.userDetails && (!this.userDetails["thirdPartyBackup"] || this.userDetails["thirdPartyBackup"]["enableTPB"] != 'Y') && item.title === 'CloudBridge' ) ) {
      item.hidden = true; 
    } else if ((!env["enableTeamFolders"] || !this.userDetails["jcEntInfo"]) && item.title === 'Team Folder') {
      item.hidden = true; 
    }else if(this.userDetails["jcEntInfo"]&& item.title === 'Albums'){
      item.hidden = true;
    }else if((this.userDetails["isPplTabOn"] == "I" || this.userDetails["isPplTabOn"] == "A" ||  this.userDetails["isPplTabOn"] == "H") && item.title === 'People' && !this.userDetails["jcEntInfo"]){
      item.hidden = false;
    }else if((this.userDetails["isPplTabOn"] != "I" &&  this.userDetails["isPplTabOn"] != "A" &&  this.userDetails["isPplTabOn"] != "H") && item.title === 'People'){
      item.hidden = true;
    }else if(item.title === 'Places' && this.userDetails["features"] && this.userDetails["features"]["places"]["isPlacesTabOn"] == "Y"){
      item.hidden = false;
    }else if(this.userDetails["privateFolder"] && (((this.userDetails.privateFolder.allowPPF == 'Y' &&  this.userDetails.privateFolder.isPPFEnabled == 'N') || this.userDetails.privateFolder.allowPPF == 'D')) && item.title === 'Private Folder'){
      item.hidden = true;
    }else if((this.userDetails["privateFolder"] &&  this.userDetails.privateFolder.allowPPF == 'Y' &&  this.userDetails.privateFolder.isPPFEnabled == 'Y') && item.title === 'Private Folder'){
      item.hidden = false;
    }else if((this.userDetails && this.userDetails["jcEntInfo"]) && item.title === 'Team Folders'){
      item.hidden = false;
    }else if(this.userDetails && item.entcontact == true && this.userDetails["jcEntInfo"] && item.title === 'Contacts'){
      item.hidden = false;
    } else if(item.title === 'DigiLocker' && (this.userDetails["digiLocker"] && this.userDetails["digiLocker"]["enableDL"] == 'Y')){
      item.hidden = false;
    } else if(item.title === 'JioPhoneCall AI' && this.userDetails['jioPhoneCallAI']?.isJpcAITabOn == 'A'){
      item.hidden = false;
    } else if(item.title === 'JioPhoneCall AI' && this.userDetails['jioPhoneCallAI']?.isJpcAITabOn !== 'A'){
      item.hidden = true;
    }else if(item.title === 'Events' && this.userDetails["features"] && this.userDetails["features"]["jioEvents"]["enableJioEvents"] == "Y"){
      item.hidden = false;
    }

    
  }
  applyMenuVisibilityConditions() {
    setTimeout(()=>{
      this.menuItems.forEach(item => this.setMenuItemVisibility(item));
      this.secondryMenuItems.forEach(item => this.setMenuItemVisibility(item));
      if(this.moreMenuItems[0] && this.moreMenuItems[0].moremenu){
        this.moreMenuItems[0].moremenu.forEach(item => this.setMenuItemVisibility(item));
      }
      
      this.leftMenu?.menuItems.forEach(item => this.setMenuItemVisibility(item));
      this.leftMenu.secondryMenuItems.forEach(item => this.setMenuItemVisibility(item));
      if(this.leftMenu.MoreLeftMenu[0] && this.leftMenu.MoreLeftMenu[0].moremenu){
        this.leftMenu.MoreLeftMenu[0].moremenu.forEach(item => this.setMenuItemVisibility(item));
      }
    },100)
  }

  expandMoreMenuAndHighlight(){
    let classRef = this;
    AppEvents.removeAllEventListener(EventsList.EXPAND_SIDEBAR_MORE_MENU);
    AppEvents.on(EventsList.EXPAND_SIDEBAR_MORE_MENU, function(view){
      setTimeout(()=>{
        if(classRef.moreMenuItems[0].expanded == false){
          let el = document.getElementById('left-more-menu')
          classRef.moreMenuItems[0].expanded = true
          if(el){
            el.classList.add('expanded');
          }
          if(classRef.router.url.includes('privatefolder')){
            classRef.isMenuItemSelected('PrivateFolder')
          }
        }
        if(classRef.moreMenuItems[0].expanded == true){
          if(classRef.router.url.includes('privatefolder')){
            classRef.isMenuItemSelected('PrivateFolder')
          }
        }
      },250)
    })
  }

}
